import { ENVIRONMENTS } from 'cu-master-layout-prop-manager';

import { env } from './env';

// Our environment names to the ids cu-master-layout-2 knows (it calls test QA). The shell picks its own API by this id.
const SHELL_ENVIRONMENTS = { test: ENVIRONMENTS.QA, production: ENVIRONMENTS.PROD } as const;

export const appConfig = {
  app: {
    rootElementId: env.appRootElementId,
    masterLayoutUrl: env.masterLayoutUrl,
  },
  shell: {
    // VITE_ENVIRONMENT_ID as in cuc-data-explorer-fe; without it, the build mode decides.
    env: env.environmentId
      ? SHELL_ENVIRONMENTS[env.environmentId]
      : env.mode === 'production'
        ? ENVIRONMENTS.PROD
        : ENVIRONMENTS.QA,
    // This app's path in the shell menu. Placeholder until the menu item exists in cu-master-layout-2 (ADR-003).
    activeLink: '/workflows',
  },
  auth: {
    staleStateAgeInSeconds: 3600,
    automaticSilentRenew: true,
  },
  session: {
    cookieName: env.sessionCookieName,
    cookieDomain: env.sessionCookieDomain,
    allowedDomains: env.sessionAllowedDomains
      .split(',')
      .map((domain) => domain.trim())
      .filter(Boolean),
    pollIntervalMs: 2000,
  },
  query: {
    refetchOnWindowFocus: false,
    staleTime: 0,
    gcTime: 0,
    networkMode: 'online',
  },
} as const;

export type AppConfig = typeof appConfig;
